import { __decorate } from "tslib";
import { Sim } from '@dooboostore/simple-boot';
export var YahooFinanceService;
(function (YahooFinanceService) {
    YahooFinanceService.SYMBOL = Symbol.for('YahooFinanceService');
})(YahooFinanceService || (YahooFinanceService = {}));
export default (container) => {
    let YahooFinanceServiceImpl = class YahooFinanceServiceImpl {
        constructor() {
            // TossService와 동일 CORS 프록시 (서버/브라우저 모두 동작)
            Object.defineProperty(this, "CORS_PROXY", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'https://sparkling-dew-b13c.visualkhh.workers.dev/?url='
            });
            Object.defineProperty(this, "CHART_BASE", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'https://query1.finance.yahoo.com/v8/finance/chart'
            });
        }
        async fetchJson(url) {
            // 정적 배포 전제: 전부 workers 프록시 경유 (dev 포함)
            const target = `${this.CORS_PROXY}${encodeURIComponent(url)}`;
            const res = await fetch(target, { headers: { accept: 'application/json' } });
            if (!res.ok)
                throw new Error(`HTTP ${res.status}`);
            return (await res.json());
        }
        async chart(symbol, query, interval = '1d') {
            const url = `${this.CHART_BASE}/${encodeURIComponent(symbol)}?${query}&interval=${interval}`;
            const json = await this.fetchJson(url);
            const res = json?.chart?.result?.[0];
            if (!res)
                throw new Error('Invalid chart response');
            const ts = res.timestamp ?? [];
            const q = res.indicators?.quote?.[0] ?? {};
            const cl = q.close ?? [];
            const op = q.open ?? [];
            const hi = q.high ?? [];
            const lo = q.low ?? [];
            const vo = q.volume ?? [];
            const out = [];
            const isMin = interval.startsWith('1m') || interval.startsWith('min');
            ts.forEach((t, i) => {
                const c = cl[i];
                if (c == null || !Number.isFinite(c))
                    return;
                out.push({
                    date: isMin
                        ? new Date(t * 1000).toISOString().slice(0, 16)
                        : new Date(t * 1000).toISOString().slice(0, 10),
                    close: c, ts: t,
                    open: op[i] ?? undefined, high: hi[i] ?? undefined,
                    low: lo[i] ?? undefined, volume: vo[i] ?? undefined,
                });
            });
            return out;
        }
        async getDaily(symbol, range = '1y') {
            return this.chart(symbol, `range=${encodeURIComponent(range)}`);
        }
        async getDailyRange(symbol, period1, period2, interval = '1d') {
            return this.chart(symbol, `period1=${period1}&period2=${period2}`, interval);
        }
        async getMacroDaily(range = '1y') {
            const [tnx, wti, spx] = await Promise.all([
                this.getDaily('^TNX', range),
                this.getDaily('CL=F', range),
                this.getDaily('^GSPC', range),
            ]);
            return { tnx, wti, spx };
        }
    };
    YahooFinanceServiceImpl = __decorate([
        Sim({ symbol: YahooFinanceService.SYMBOL, container })
    ], YahooFinanceServiceImpl);
    return YahooFinanceServiceImpl;
};
